import { render, staticRenderFns } from "./glitRegistration.vue?vue&type=template&id=a8a0a4e2&scoped=true&"
import script from "./glitRegistration.vue?vue&type=script&lang=js&"
export * from "./glitRegistration.vue?vue&type=script&lang=js&"
import style0 from "./glitRegistration.vue?vue&type=style&index=0&id=a8a0a4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a0a4e2",
  null
  
)

export default component.exports